import * as React from 'react';
import { StyledInputSearch, Icon } from './Search.style';
import { SearchProps } from './Search.types';

const NOOP = () => { };

export const Search = React.memo((props: SearchProps) => {
  const { onSearch = NOOP, total = 1, debounce = false } = props;
  const timer = React.useMemo<any>(() => ({id: null}), []);

  const handlerChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    clearTimeout(timer.id);
    const timeout = Math.ceil(debounce ? (total / 100) * 10 : 0);
    timer.id = setTimeout(() => onSearch(value), timeout > 1000 ? 1000 : timeout);
  }, []);

  return (<StyledInputSearch
    onChange={handlerChange}
    variant="standard"
    placeholder="Quick search"
    InputProps={{
      className: 'hierarchy-search-input',
      endAdornment: <Icon />
    }}
  />);
});